import React from "react";

function SubButton(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      fill="none"
      viewBox="0 0 27 27"
      {...props}
    >
      <circle cx="13.5" cy="13.5" r="13" stroke="#ED9995"></circle>
      <path fill="#ED9995" d="M8 14v-1h11v1H8z"></path>
    </svg>
  );
}

export default SubButton;
